import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for `/statements/$period/*` (mirrors `statements.tsx`'s and
 * `bookings.$reference.tsx`'s fix — see either file's comment for the full
 * mechanism). Because `statements.$period.print.tsx` exists alongside this
 * file, TanStack Router makes this the PARENT of the print route, so this
 * file renders `<Outlet/>` only and the detail UI lives in
 * `statements.$period.index.tsx` (`/statements/$period/`).
 */
export const Route = createFileRoute('/statements/$period')({
  component: StatementPeriodLayout,
});

function StatementPeriodLayout() {
  return <Outlet />;
}
